<div class="view-container">
  <mat-card class="medicine-list-container">
    <div class="medicine-list__header">
      <div class="mbp-page-header">
        <div class="mbp-page-header__icon">
          <mat-icon>medication</mat-icon>
        </div>
        <h1 class="mbp-page-header__title">Medicine</h1>
      </div>

      <mat-form-field
        appearance="outline"
        class="medicine-list__search"
        subscriptSizing="dynamic"
      >
        <input matInput placeholder="Search medicine" [formControl]="medicineNameInput" />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
    </div>

    <mat-paginator
      class="medicine-list__paginator"
      [length]="totalNumberOfMedicine"
      [pageIndex]="page - 1"
      [pageSize]="limit"
      [pageSizeOptions]="[10, 15, 20]"
      showFirstLastButtons
      (page)="onPageChange($event)"
      aria-label="Select page of medicine"
    >
    </mat-paginator>

    <div class="mbp-table-wrap">
      <table
        mat-table
        [dataSource]="medicineDataSource"
        class="mbp-data-table medicine-list"
        matSort
        (matSortChange)="sortMedicine($event)"
      >
        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by Name"
            start="desc"
            class="name-col"
          >
            Name
          </th>
          <td mat-cell *matCellDef="let medicine" class="name-col">{{ medicine.name }}</td>
        </ng-container>

        <ng-container matColumnDef="barcode_prefix">
          <th mat-header-cell *matHeaderCellDef>Barcode prefix</th>
          <td mat-cell *matCellDef="let medicine">{{ medicine.barcode_prefix }}</td>
        </ng-container>

        <ng-container matColumnDef="active_ingredient">
          <th mat-header-cell *matHeaderCellDef>Active ingredient</th>
          <td mat-cell *matCellDef="let medicine">{{ medicine.active_ingredient }}</td>
        </ng-container>

        <ng-container matColumnDef="schedule_status">
          <th mat-header-cell *matHeaderCellDef>Schedule status</th>
          <td mat-cell *matCellDef="let medicine">{{ medicine.schedule_status }}</td>
        </ng-container>

        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let medicine">{{ formatTime(medicine.created_at) }}</td>
        </ng-container>

        <ng-container matColumnDef="updated">
          <th mat-header-cell *matHeaderCellDef>Updated</th>
          <td mat-cell *matCellDef="let medicine">{{ formatTime(medicine.updated_at) }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          (click)="openMedicine(row.id)"
          mat-row
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>
  </mat-card>
</div>
